const STORAGE_KEY = "runzr.pairedDevice";

export function loadPairedDevice() {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const payload = JSON.parse(raw);
    if (!payload || typeof payload.deviceKey !== "string" || payload.deviceKey.length < 8) {
      return null;
    }
    return payload;
  } catch {
    return null;
  }
}

export function savePairedDevice(deviceKey, deviceName) {
  if (typeof window === "undefined") return null;

  const payload = {
    deviceKey,
    deviceName: deviceName || "Windows Laptop",
    connectedAt: new Date().toISOString(),
  };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function clearPairedDevice() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
}
